export default __webpack_public_path__ + "static/media/flask.611b5611.svg";